import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useOrganizationProfiles } from '~/entities/profile/model/use-profiles'
import { ActionPlaceCard } from '~/features/listing-actions/components/action-place-card'
import { GoodForCard } from '~/features/listing-good-for/components/good-for-card'
import { ListingDetailHeader } from '~/features/listings/components/listing-detail-header'
import { ListingDetailsCard } from '~/features/listings/components/listing-detail-overview'
import { ListingNumbersCard } from '~/features/listings/components/listing-numbers-card'
import { PlaceFlyersCard } from '~/features/place-flyers/components/place-flyers-card'
import { SearchReadinessCard } from '~/features/search-readiness/components/search-readiness-card'
import { VenueRoomCard } from '~/features/venue-room/components/venue-room-card'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { DetailPageGrid } from '~/widgets/detail-page-grid'
import { PlaceAdvancedCard } from '~/widgets/place-advanced-card'

export const Route = createFileRoute('/dashboard/listings/$listingId/')({
  component: ListingDetail,
})

function ListingDetail() {
  const { listingId } = Route.useParams()
  const { data: business } = useCurrentBusiness()
  const { enabled, active } = useOrganizationProfiles(business?.id)
  const isProfileHome = enabled && active?.listingId === listingId

  return (
    <div className="mx-auto w-full max-w-7xl space-y-6">
      {isProfileHome ? null : (
        <Button asChild variant="ghost" size="sm" className="w-fit">
          <Link to="/dashboard/listings">
            <ArrowLeft className="h-4 w-4" />
            {m.backToListings()}
          </Link>
        </Button>
      )}
      <ListingDetailHeader listingId={listingId} />
      <DetailPageGrid
        top={<ListingNumbersCard listingId={listingId} />}
        side={
          <>
            <VenueRoomCard listingId={listingId} />
            <PlaceFlyersCard listingId={listingId} />
            <SearchReadinessCard listingId={listingId} />
            <GoodForCard listingId={listingId} />
          </>
        }
      >
        <ListingDetailsCard listingId={listingId} />
        <ActionPlaceCard listingId={listingId} />
        <PlaceAdvancedCard listingId={listingId} />
      </DetailPageGrid>
    </div>
  )
}
